// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rDNA-dashboardContainer .rDNA-loader, .rDNA-dashboardContainer .rDNA-prev-next-container, .rDNA-dashboardContainer .rDNA-button, .rDNA-dashboardContainer .rDNA-smBtnStack {
  display: flex;
  flex-direction: column;
}

.rDNA-dashboardContainer .rDNA-companyTitleInList, .rDNA-dashboardContainer .rDNA-companyTitle {
  display: flex;
  flex-direction: row;
}

.rDNA-dashboardContainer .rDNA-loader, .rDNA-dashboardContainer .rDNA-prev-next-container, .rDNA-dashboardContainer .rDNA-button {
  justify-content: center;
  align-items: center;
}

.rDNA-dashboardContainer .rDNA-companyTitleInList, .rDNA-dashboardContainer .rDNA-companyTitle {
  justify-content: flex-start;
  align-items: center;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
.rDNA-dashboardContainer .rDNA-companyTitle {
  font-family: "Dm Sans", sans-serif;
  font-size: 34px;
  font-weight: 700;
  font-style: normal;
}

.rDNA-dashboardContainer .rDNA-companyTitleInList {
  font-family: "Dm Sans", sans-serif;
  font-size: 20px;
  font-weight: 700;
  font-style: normal;
}

.rDNA-dashboardContainer .rDNA-echelon ::ng-deep .echelon-header > p {
  font-family: "Dm Sans", sans-serif;
  font-size: 24px;
  font-weight: 600;
  font-style: normal;
}

.rDNA-dashboardContainer .rDNA-prev-next-container p, .rDNA-dashboardContainer .rDNA-button {
  font-family: "Dm Sans", sans-serif;
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
}

.rDNA-dashboardContainer .rDNA-loader, .rDNA-dashboardContainer .rDNA-retailerSection, .rDNA-dashboardContainer .rDNA-rankings, .rDNA-dashboardContainer .rDNA-metricsSection, .rDNA-dashboardContainer .rDNA-generalInfo {
  height: 100%;
  width: 100%;
}

@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 900;
  src: url('DMSans-Black.488392488fc1755c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 800;
  src: url('DMSans-ExtraBold.a5b0ab310755ef77.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  src: url('DMSans-Bold.5d8f19212e66f41c.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 600;
  src: url('DMSans-SemiBold.ba81386aaa3f8bec.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 500;
  src: url('DMSans-Medium.6e411356edf4bc5d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  src: url('DMSans-Regular.254fafcf32e78d93.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 300;
  src: url('DMSans-Light.195d851006084602.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 200;
  src: url('DMSans-ExtraLight.a1df2f9a2054461d.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 100;
  src: url('DMSans-Thin.a9d11007dfa31cfb.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 900;
  src: url('DMSans-BlackItalic.6085069ea3ad7499.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 800;
  src: url('DMSans-ExtraBoldItalic.43c17c588c612b92.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 700;
  src: url('DMSans-BoldItalic.05455c47a70f72be.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 600;
  src: url('DMSans-SemiBoldItalic.7afda8ff11873b51.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 500;
  src: url('DMSans-MediumItalic.2f9b70a7382ac1bd.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 400;
  src: url('DMSans-Italic.da827be69095140a.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 300;
  src: url('DMSans-LightItalic.9ac218ec8d449389.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 200;
  src: url('DMSans-ExtraLightItalic.201c8891fc6a2a4e.ttf');
}
@font-face {
  font-family: "DM Sans";
  font-style: italic;
  font-weight: 100;
  src: url('DMSans-ThinItalic.65c007651b2972db.ttf');
}
/* Old palette
\$accent-btn: #DD7EB0;
\$dark-text: #303f71;
\$light-text: #fff;
\$inactive-text: #A3AED0;
\$accent-blue: #84D9FD;*/
/** Colors variables */
.sb-default .sb-wrapper {
  --sb-color: #fff;
  --sb-background: var(--button-color);
  --sb-border-radius: 4px;
  --sb-overflow: hidden;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text {
  --sb-text-padding: 0 1em 0 0;
}
.sb-default .sb-wrapper.sb-show-icon.sb-show-text .sb-text {
  filter: none;
}

/** Colors variables */
.sb-circles-dark .sb-wrapper, .sb-circles-light .sb-wrapper {
  --sb-color: #fff;
  --sb-background: transparent;
  --sb-min-width: fit-content;
  --sb-height: fit-content;
  --sb-icon-size: 1.4em;
}
.sb-circles-dark .sb-wrapper:active .sb-icon, .sb-circles-light .sb-wrapper:active .sb-icon {
  box-shadow: 0 7px 8px -4px rgba(0, 0, 0, 0.2), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 5px 22px 4px rgba(0, 0, 0, 0.12);
}
.sb-circles-dark .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-icon {
  background-color: var(--button-color);
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 2.5em;
  min-height: 2.5em;
  border-radius: 50%;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-text, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
  font-size: 0.8em;
  margin-top: 5px;
  border-radius: 1em;
  width: 100%;
  height: 1.8em;
  line-height: 1.8em;
  padding: 0;
  transition: background 0.4s cubic-bezier(0.25, 0.8, 0.25, 1), box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
}
.sb-circles-dark .sb-wrapper .sb-content, .sb-circles-light .sb-wrapper .sb-content {
  align-items: center;
  flex-direction: column;
}

.sb-circles-dark .sb-wrapper .sb-icon {
  background-color: var(--button-color);
}
.sb-circles-dark .sb-wrapper .sb-text {
  color: var(--button-color);
}

.sb-circles-light .sb-wrapper .sb-icon, .sb-circles-light .sb-wrapper .sb-text {
  color: var(--button-color);
}
.sb-circles-light .sb-wrapper .sb-icon {
  background: radial-gradient(ellipse farthest-corner at center, white 30%, #f2f2f2 100%);
}

/* You can add global styles to this file, and also import other style files */
body, html {
  height: 100vh;
  margin: 0;
}

body {
  font-family: Arial, sans-serif;
  height: 100vh;
  background-color: #fff; /* Background color for the top half */
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
}

body::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background: #fff;
  z-index: -1; /* Ensure the gradient is behind other content */
}

/* Old palette
\$theme-main: #B05995;
\$theme-contrast: #3792BF;
\$theme-1: #282B59;
\$theme-2: #D683DD;
\$theme-3: #27567A;
\$theme-4: #44DDC4;
\$theme-5: #3336AE;
\$theme-6: #18C43D;
*/
.material-symbols-outlined {
  cursor: pointer;
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  color: #2D2D2A;
}

html, body {
  height: 100%;
}

body {
  margin: 0;
  font-family: Roboto, "Helvetica Neue", sans-serif;
}

.generic-button, .generic-button-alt {
  color: white;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding for button size */
  margin-right: 10px;
  cursor: pointer; /* Pointer on hover */
  transition: background-color 0.3s; /* Smooth transition on hover */
}
.generic-button p, .generic-button-alt p {
  color: white;
  margin: 0;
}

.generic-button {
  background-color: #1B3E78; /* Button background color */
  border: 2px solid #1B3E78; /* No border */
}

.generic-button-alt {
  background-color: #0CAD99; /* Button background color */
  border: 2px solid #0CAD99; /* No border */
}

.generic-button:hover {
  background-color: #fff; /* Change color on hover */
  color: #1B3E78;
}
.generic-button:hover p {
  color: #1B3E78;
}

.generic-button-alt:hover {
  background-color: #fff; /* Change color on hover */
  color: #0CAD99;
}
.generic-button-alt:hover p {
  color: #0CAD99;
}

.generic-button:disabled, .generic-button-alt:disabled {
  background-color: #e7e7e7;
  border-color: #e7e7e7;
  cursor: not-allowed;
}

.rDNA-dashboardContainer {
  height: 100%;
  max-width: 90vw;
}
.rDNA-dashboardContainer .export-btn {
  border: 1px solid #1B3E78;
}
.rDNA-dashboardContainer .rDNA-buttonBar {
  width: 100%;
}
.rDNA-dashboardContainer .rDNA-smBtnStack {
  width: 100%;
}
.rDNA-dashboardContainer .rDNA-button {
  border-radius: 15px;
}
.rDNA-dashboardContainer .rDNA-button:last-of-type {
  margin-bottom: 0;
}
.rDNA-dashboardContainer .rDNA-prev-next-container {
  justify-content: space-around;
  align-items: center;
  background-color: #e7e7e7;
  border-radius: 100px;
  height: 100px;
  width: 80%;
  margin: 0;
  padding: 5% 10px;
}
.rDNA-dashboardContainer .rDNA-prev-next-container .sub-container {
  display: flex;
  flex-direction: row;
  height: 50%;
  align-items: center;
}
.rDNA-dashboardContainer .rDNA-prev-next-container div {
  width: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-around;
}
.rDNA-dashboardContainer .rDNA-prev-next-container p {
  color: #2D2D2A;
  margin: 15px;
}
.rDNA-dashboardContainer .rDNA-prev-next-container span {
  color: #e7e7e7;
  font-weight: bold;
  background-color: white;
  border-radius: 100%;
  border: none;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
}
.rDNA-dashboardContainer .rDNA-prev-next-container span:last-of-type {
  margin-left: 5px;
}
.rDNA-dashboardContainer .rDNA-prev-next-container span:hover {
  color: #1B3E78;
}
.rDNA-dashboardContainer .rDNA-echelonContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.rDNA-dashboardContainer .rDNA-echelon {
  max-width: 100% !important;
}
.rDNA-dashboardContainer .rDNA-echelon ::ng-deep .echelon-header {
  background: #1B3E78;
  border-radius: 10px;
}
.rDNA-dashboardContainer .rDNA-echelon ::ng-deep .echelon-header > p {
  color: #fff;
}
.rDNA-dashboardContainer .rDNA-companyTitle {
  width: 100%;
}
.rDNA-dashboardContainer .rDNA-companyTitle div {
  display: flex;
  flex-wrap: wrap;
}
.rDNA-dashboardContainer .rDNA-companyTitle p {
  margin: 0;
}
.rDNA-dashboardContainer .rDNA-companyTitle .clickable {
  text-decoration: underline;
  color: #1B3E78;
}
.rDNA-dashboardContainer .rDNA-companyTitle .clickable:hover {
  cursor: pointer;
  color: #0CAD99;
}
.rDNA-dashboardContainer .rDNA-companyTitleInList {
  width: 100%;
}
.rDNA-dashboardContainer .rDNA-companyTitleInList div {
  display: flex;
  flex-wrap: wrap;
}
.rDNA-dashboardContainer .rDNA-companyTitleInList div p {
  margin: 0;
}
.rDNA-dashboardContainer .rDNA-companyTitleInList .clickable {
  text-decoration: underline;
  color: #1B3E78;
}
.rDNA-dashboardContainer .rDNA-companyTitleInList .clickable:hover {
  cursor: pointer;
  color: #0CAD99;
}
.rDNA-dashboardContainer .share-btn {
  color: #fff;
  background: #1B3E78;
}
.rDNA-dashboardContainer .compare-btn {
  color: #fff;
  background: #0CAD99;
  width: 100%;
  margin-right: 20px;
  margin-bottom: 10px;
}

@media screen and (max-width: 767.7px) {
  .rDNA-dashboardMobile {
    background: #F4F7FE;
    padding: 0 25px 0 10px;
  }
  .rDNA-dashboardMobile .rDNA-mobileWebDomain {
    display: flex;
    margin-bottom: 10px;
  }
  .rDNA-dashboardMobile .rDNA-companyName {
    color: #282B59;
    font-size: 30px;
    font-family: "DM Sans", sans-serif;
    font-weight: 700;
    margin: 0 0 20px 10px;
    padding-top: 15px;
  }
  .rDNA-dashboardMobile .rDNA-companyNameInList {
    color: #282B59;
    font-size: 30px;
    font-family: "DM Sans", sans-serif;
    font-weight: 700;
    margin: 0 0 20px 10px;
    padding-top: 15px;
  }
  .rDNA-dashboardMobile .rDNA-prev-next-container {
    display: flex;
    flex-direction: row;
    align-self: center;
    justify-content: space-between;
    align-items: center;
    background-color: #e7e7e7;
    border-radius: 40px;
    margin: 5px 0px;
    padding: 0px 10px;
  }
  .rDNA-dashboardMobile .rDNA-prev-next-container .ret-container {
    display: flex;
    flex-direction: row;
    width: -moz-fit-content;
    width: fit-content;
    max-width: 50%;
    height: 100%;
    align-items: center;
  }
  .rDNA-dashboardMobile .rDNA-prev-next-container div {
    width: 50%;
    display: flex;
    justify-content: space-evenly;
  }
  .rDNA-dashboardMobile .rDNA-prev-next-container p {
    font-size: 12px;
    color: #2D2D2A;
    margin: 0 15px;
  }
  .rDNA-dashboardMobile .rDNA-prev-next-container span {
    color: #e7e7e7;
    font-weight: bold;
    font-size: 30px;
    background-color: white;
    border-radius: 100%;
    border: none;
    width: -moz-fit-content;
    width: fit-content;
    height: -moz-fit-content;
    height: fit-content;
  }
  .rDNA-dashboardMobile .rDNA-prev-next-container span:hover {
    color: #1B3E78;
  }
  .rDNA-dashboardMobile .rDNA-echelonContainer {
    max-width: 70vw;
    justify-content: space-around;
  }
  .rDNA-dashboardMobile .rDNA-echelon ::ng-deep .echelon {
    width: 100% !important;
  }
  .rDNA-dashboardMobile .rDNA-echelon ::ng-deep .echelon-header {
    background: #1B3E78;
  }
  .rDNA-dashboardMobile .rDNA-echelon ::ng-deep .echelon-header > p {
    color: #fff !important;
    font-size: 16px;
    margin: 10px;
  }
}
@media screen and (max-width: 1023.7px) and (min-width: 768px) {
  .rDNA-dashboardContainer {
    padding: 5px;
  }
  .rDNA-dashboardContainer .rDNA-companyTitle {
    font-size: 30px;
    padding-left: 5px;
  }
  .rDNA-dashboardContainer .rDNA-companyTitleInList {
    font-size: 20px;
    padding-left: 5px;
  }
  .rDNA-dashboardContainer .rDNA-button {
    height: 25px;
    margin-bottom: 5px;
    font-size: 9px;
  }
  .rDNA-dashboardContainer .rDNA-button span {
    margin-left: 5px;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container {
    width: 80%;
    height: 60px;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container p {
    font-size: 12px;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container span {
    font-size: 15px;
  }
  .rDNA-dashboardContainer .compare-btn {
    width: 100%;
    margin-right: 10px;
    margin-bottom: 0;
  }
  .rDNA-dashboardContainer .rDNA-smBtnStack {
    width: 100%;
  }
  .rDNA-dashboardContainer .rDNA-echelonContainer {
    justify-content: space-around;
  }
  .rDNA-dashboardContainer .rDNA-echelon {
    margin-top: 10px;
  }
  .rDNA-dashboardContainer .rDNA-echelon ::ng-deep .echelon-header > p {
    font-size: 16px;
    margin: 10px;
  }
  .padlock-container {
    position: relative;
  }
  .padlock {
    display: none;
  }
  .padlock.disabled {
    display: block;
  }
}
@media screen and (max-width: 1199.7px) and (min-width: 1024px) {
  .rDNA-dashboardContainer {
    padding: 10px;
  }
  .rDNA-dashboardContainer .rDNA-companyTitle {
    padding-left: 20px;
  }
  .rDNA-dashboardContainer .rDNA-companyTitleInList {
    font-size: 24px;
    padding-left: 5px;
  }
  .rDNA-dashboardContainer .rDNA-button {
    height: 35px;
    width: 45%;
    margin-bottom: 5px;
    font-size: 9px;
  }
  .rDNA-dashboardContainer .rDNA-button span {
    margin-left: 5px;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container {
    width: 80%;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container p {
    font-size: 16px;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container span {
    font-size: 25px;
  }
  .rDNA-dashboardContainer .rDNA-smBtnStack {
    width: 50%;
  }
  .rDNA-dashboardContainer .compare-btn {
    width: 100%;
    margin-right: 0px;
    margin-bottom: 0;
  }
  .rDNA-dashboardContainer .rDNA-echelonContainer {
    justify-content: space-around;
  }
  .rDNA-dashboardContainer .rDNA-echelon {
    margin-top: 15px;
  }
  .rDNA-dashboardContainer .rDNA-echelon ::ng-deep .echelon-header > p {
    font-size: 20px;
    margin: 10px;
  }
}
@media screen and (min-width: 1675px) {
  .rDNA-echelonContainer {
    justify-content: space-between !important;
  }
}
@media screen and (max-width: 2559.7px) and (min-width: 1199.7px) {
  .rDNA-dashboardContainer {
    padding: 15px;
  }
  .rDNA-dashboardContainer .rDNA-companyTitle {
    padding-left: 25px;
  }
  .rDNA-dashboardContainer .rDNA-companyTitleInList {
    font-size: 25px;
    padding-left: 5px;
  }
  .rDNA-dashboardContainer .rDNA-smBtnStack {
    width: 50%;
  }
  .rDNA-dashboardContainer .rDNA-button {
    height: 35px;
    width: 45%;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .rDNA-dashboardContainer .rDNA-button span {
    margin-left: 10px;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container {
    width: 80%;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container p {
    font-size: 16px;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container span {
    font-size: 28px;
  }
  .rDNA-dashboardContainer .compare-btn {
    width: 100%;
    margin-right: 20px;
    margin-bottom: 0;
  }
  .rDNA-dashboardContainer .rDNA-echelonContainer {
    max-width: 90vw;
    display: flex;
  }
  .rDNA-dashboardContainer .rDNA-echelon {
    margin-top: 20px;
  }
  .rDNA-dashboardContainer .rDNA-echelon ::ng-deep .echelon-header > p {
    font-size: 24px;
    margin: 10px;
  }
}
@media screen and (min-width: 2560px) {
  .rDNA-dashboardContainer {
    padding: 25px;
  }
  .rDNA-dashboardContainer .rDNA-companyTitle {
    padding-left: 32px;
  }
  .rDNA-dashboardContainer .rDNA-companyTitleInList {
    font-size: 42;
  }
  .rDNA-dashboardContainer .rDNA-button {
    height: 45px;
    width: 45%;
    margin-bottom: 20px;
    border-radius: 15px;
    font-size: 20px;
  }
  .rDNA-dashboardContainer .rDNA-button span {
    margin-left: 20px;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container {
    width: 80%;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container p {
    font-size: 20px;
  }
  .rDNA-dashboardContainer .rDNA-prev-next-container span {
    font-size: 28px;
  }
  .rDNA-dashboardContainer .compare-btn {
    width: 100%;
    margin-right: 20px;
    margin-bottom: 0;
  }
  .rDNA-dashboardContainer .rDNA-echelonContainer {
    max-width: 90vw;
  }
  .rDNA-dashboardContainer .rDNA-echelon {
    margin-top: 35px;
  }
  .rDNA-dashboardContainer .rDNA-echelon ::ng-deep .echelon-header > p {
    font-size: 24px;
  }
}
@media (max-width: 767px) {
  .app-lb-banner {
    flex-direction: column;
  }
  app-lb-full-width-dropdown {
    margin: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/placeholders/_flexboxes.scss","webpack://./src/app/profiles/dashboard/dashboard.component.scss","webpack://./src/theme/fonts.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/placeholders/_fonts.scss","webpack://./src/theme/mixins.scss","webpack://./src/theme/placeholders/_quickStyles.scss","webpack://./node_modules/ngx-sharebuttons/themes/variables.scss","webpack://./node_modules/ngx-sharebuttons/themes/default.scss","webpack://./node_modules/ngx-sharebuttons/themes/circles.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AACA;EAC0B,aAAA;EACA,sBAAA;ACA1B;;ADGA;EAC0B,aAAA;EACA,mBAAA;ACA1B;;ADGA;EAC0B,uBAAA;EACA,mBAAA;ACA1B;;ADaA;EAC0B,2BAAA;EACA,mBAAA;ACV1B;;AClBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADqBF;AClBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ADoBF;ACjBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADmBF;AChBA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ADkBF;ACfA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADiBF;ACdA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ADgBF;ACbA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADeF;ACZA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADcF;ACXA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADaF;ACVA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADYF;ACTA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;ADWF;ACRA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADUF;ACPA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;ADSF;ACNA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;ADQF;ACLA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADOF;ACJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADMF;ACHA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ADKF;ACFA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADIF;AExHA;;;;;uBAAA;ACOA;ECEE,kCFXY;EEYZ,eDH2C;ECI3C,gBATiF;EAUjF,kBALgB;AJ6HlB;;AGzHA;ECFE,kCFXY;EEYZ,eDC2C;ECA3C,gBATiF;EAUjF,kBALgB;AJoIlB;;AGrHA;ECbE,kCFXY;EEYZ,eDY2C;ECX3C,gBAVgJ;EAWhJ,kBALgB;AJ2IlB;;AGnHA;ECtBE,kCFXY;EEYZ,eDqB2C;ECpB3C,gBAXqF;EAYrF,kBALgB;AJkJlB;;AK/JA;EACE,YAAA;EACA,WAAA;ALkKF;;ACrKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADwKF;ACrKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;ADuKF;ACpKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADsKF;ACnKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gDAAA;ADqKF;AClKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;ADoKF;ACjKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;ADmKF;AChKA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6CAAA;ADkKF;AC/JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADiKF;AC9JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;ADgKF;AC7JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;AD+JF;AC5JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uDAAA;AD8JF;AC3JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AD6JF;AC1JA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sDAAA;AD4JF;ACzJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oDAAA;AD2JF;ACxJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;AD0JF;ACvJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mDAAA;ADyJF;ACtJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;ADwJF;ACrJA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;ADuJF;AE3QA;;;;;uBAAA;AIPA,sBAAA;ACEA;EACE,gBAAA;EACA,oCAAA;EACA,uBAAA;EACA,qBAAA;APyRF;AOvRE;EACE,4BAAA;APyRJ;AOvRI;EACE,YAAA;APyRN;;AMrSA,sBAAA;AEME;EACE,gBAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,qBAAA;ARmSJ;AQhSM;EACE,sHAAA;ARkSR;AQ9RI;EACE,qCAAA;EACA,iHAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2GAAA;ARgSN;AQ7RI;EACE,0BAAA;EACA,gBA3BS;EA4BT,eAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,2GAAA;AR+RN;AQ5RI;EACE,mBAAA;EACA,sBAAA;AR8RN;;AQvRE;EACE,qCAAA;AR0RJ;AQvRE;EACE,0BAAA;ARyRJ;;AQnRE;EACE,0BAAA;ARsRJ;AQnRE;EACE,uFAAA;ARqRJ;;ASlVA,8EAAA;AAEA;EACA,aAAA;EAEA,SAAA;ATmVA;;AShVA;EACI,8BAAA;EACA,aAAA;EACA,sBAAA,EAAA,sCAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;ATmVJ;;AS/UA;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EAGA,WAAA,EAAA,gDAAA;ATgVJ;;AS3UA;;;;;;;;;CAAA;AA0CA;EAEI,eAAA;EACA,kEACI;AT4SR;;AStSA;EACI,yCAAA;EACA,mBAAA;EACA,cAxDS;ATiWb;;ASpSA;EAAa,YAAA;ATwSb;;ASvSA;EAAO,SAAA;EAAW,iDAAA;AT4SlB;;ASzSA;EACE,YAAA;EACA,kBAAA,EAAA,oBAAA;EACE,kBAAA,EAAA,4BAAA;EACA,kBAAA;EAGA,eAAA,EAAA,qBAAA;EACA,iCAAA,EAAA,+BAAA;AT0SJ;ASxSI;EACI,YAAA;EACA,SAAA;AT0SR;;ASvSA;EACE,yBArEW,EAqEoB,4BAAA;EAC/B,yBAAA,EAAA,cAAA;AT0SF;;ASvSA;EACE,yBA7Da,EA6DoB,4BAAA;EACjC,yBAAA,EAAA,cAAA;AT0SF;;ASvSA;EACI,sBAAA,EAAA,0BAAA;EACA,cAhFS;AT0Xb;ASxSI;EACI,cAnFK;AT6Xb;;AStSA;EACE,sBAAA,EAAA,0BAAA;EACA,cA5Ea;ATqXf;ASvSE;EACE,cA/EW;ATwXf;;ASrSA;EACI,yBA/Ec;EAgFd,qBAhFc;EAiFd,mBAAA;ATwSJ;;AArbA;EACsC,YAAA;EACA,eAAA;AAwbtC;AAvbE;EAAoC,yBAAA;AA0btC;AAzbE;EAAoC,WAAA;AA4btC;AAvbE;EAEoC,WAAA;AAwbtC;AArbE;EACoC,mBAAA;AAubtC;AAlbsC;EAAiB,gBAAA;AAqbvD;AAnbE;EAMoC,6BAAA;EACA,mBAAA;EACA,yBS8BpB;ET7BoB,oBAAA;EAEA,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AA+atC;AA7asC;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AA+axC;AA5asC;EACE,WAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,6BAAA;AA8axC;AAzasC;EAEE,cS3B3B;ET4B2B,YAAA;AA0axC;AAtasC;EAEE,cSJtB;ETKsB,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EAAA,kBAAA;EACA,wBAAA;EAAA,mBAAA;AAuaxC;AAtawC;EAAe,gBAAA;AAyavD;AArasC;EACE,cSlC3B;ATycb;AAnaE;EACoC,aAAA;EACA,eAAA;EACA,6BAAA;AAqatC;AAlaE;EAEoC,0BAAA;AAmatC;AAlasC;EACE,mBElF5B;EFmF4B,mBAAA;AAoaxC;AAnawC;EAEE,WErF7B;AFyfb;AA9ZE;EACoC,WAAA;AAgatC;AA3ZsC;EACE,aAAA;EACA,eAAA;AA6ZxC;AA3ZsC;EACE,SAAA;AA6ZxC;AA1ZsC;EACE,0BAAA;EACA,cE5G5B;AFwgBZ;AAxZsC;EACE,eAAA;EACA,cEnH3B;AF6gBb;AAvZE;EACoC,WAAA;AAyZtC;AApZsC;EACE,aAAA;EACA,eAAA;AAsZxC;AArZwC;EACE,SAAA;AAuZ1C;AAnZsC;EACE,0BAAA;EACA,cErI5B;AF0hBZ;AAjZsC;EACE,eAAA;EACA,cE5I3B;AF+hBb;AA3YE;EACoC,WEnJzB;EFoJyB,mBErJ1B;AFkiBZ;AA3YE;EACoC,WEvJzB;EFwJyB,mBE1JzB;EF4JyB,WAAA;EAEA,kBAAA;EACA,mBAAA;AA2YtC;;AAvYA;EACE;IACoC,mBEvJrB;IFwJqB,sBAAA;EA0YpC;EAzYE;IACoC,aAAA;IACA,mBAAA;EA2YtC;EAzYE;IACoC,cAAA;IACA,eAAA;IACA,kCAAA;IACA,gBAAA;IACA,qBAAA;IACA,iBAAA;EA2YtC;EAzYE;IACoC,cAAA;IACA,eAAA;IACA,kCAAA;IACA,gBAAA;IACA,qBAAA;IACA,iBAAA;EA2YtC;EAzYE;IACoC,aAAA;IACA,mBAAA;IACA,kBAAA;IACA,8BAAA;IACA,mBAAA;IACA,yBS5ItB;IT6IsB,mBAAA;IAEA,eAAA;IACA,iBAAA;EA0YtC;EAxYsC;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IAAA,kBAAA;IACA,cAAA;IACA,YAAA;IACA,mBAAA;EA0YxC;EAvYsC;IACE,UAAA;IACA,aAAA;IACA,6BAAA;EAyYxC;EApYsC;IACE,eAAA;IACA,cSnM7B;IToM6B,cAAA;EAsYxC;EAlYsC;IAEE,cS5KxB;IT6KwB,iBAAA;IACA,eAAA;IACA,uBAAA;IACA,mBAAA;IACA,YAAA;IACA,uBAAA;IAAA,kBAAA;IACA,wBAAA;IAAA,mBAAA;EAmYxC;EA9XsC;IACE,cS3M7B;ET2kBX;EA5XE;IACoC,eAAA;IACA,6BAAA;EA8XtC;EA3XsC;IAAoB,sBAAA;EA8X1D;EA7XsC;IACE,mBExP9B;EFunBV;EA7XwC;IACE,sBAAA;IACA,eAAA;IACA,YAAA;EA+X1C;AACF;AAzXA;EACE;IACoC,YAAA;EA2XpC;EA1XE;IACoC,eAAA;IACA,iBAAA;EA4XtC;EA1XE;IACoC,eAAA;IACA,iBAAA;EA4XtC;EA1XE;IACoC,YAAA;IAEA,kBAAA;IACA,cAAA;EA2XtC;EA1XsC;IAAO,gBAAA;EA6X7C;EA3XE;IACoC,UAAA;IACA,YAAA;EA6XtC;EA1XsC;IACE,eAAA;EA4XxC;EA1XsC;IACE,eAAA;EA4XxC;EAzXE;IAEoC,WAAA;IACA,kBAAA;IACA,gBAAA;EA0XtC;EAxXE;IACoC,WAAA;EA0XtC;EAtXE;IAAwB,6BAAA;EAyX1B;EAxXE;IACsC,gBAAA;EA0XxC;EAtX0C;IACE,eAAA;IACA,YAAA;EAwX5C;EAnXA;IACE,kBAAA;EAqXF;EAjXA;IACE,aAAA;EAmXF;EAhXA;IACE,cAAA;EAkXF;AACF;AA/WA;EACE;IACoC,aAAA;EAiXpC;EAhXE;IAAqC,kBAAA;EAmXvC;EAlXE;IACoC,eAAA;IACA,iBAAA;EAoXtC;EAjXE;IACoC,YAAA;IACA,UAAA;IACA,kBAAA;IACA,cAAA;EAmXtC;EAlXsC;IAAO,gBAAA;EAqX7C;EAnXE;IACoC,UAAA;EAqXtC;EAnXsC;IACE,eAAA;EAqXxC;EAnXsC;IACE,eAAA;EAqXxC;EAjXI;IACkC,UAAA;EAmXtC;EAjXE;IAEoC,WAAA;IACA,iBAAA;IACA,gBAAA;EAkXtC;EAhXE;IAAwB,6BAAA;EAmX1B;EAlXE;IACsC,gBAAA;EAoXxC;EAhX0C;IACE,eAAA;IACA,YAAA;EAkX5C;AACF;AA5WA;EACE;IAAuB,yCAAA;EA+WvB;AACF;AA7WA;EACE;IACuC,aAAA;EA+WvC;EA9WE;IAAqC,kBAAA;EAiXvC;EAhXE;IACoC,eAAA;IACA,iBAAA;EAkXtC;EA/WoC;IAAkB,UAAA;EAkXtD;EAjXE;IACoC,YAAA;IACA,UAAA;IACA,mBAAA;IACA,eAAA;EAmXtC;EAlXsC;IAAO,iBAAA;EAqX7C;EAnXE;IACoC,UAAA;EAqXtC;EAnXsC;IACE,eAAA;EAqXxC;EAnXsC;IACE,eAAA;EAqXxC;EAjXE;IAEoC,WAAA;IACA,kBAAA;IACA,gBAAA;EAkXtC;EAhXE;IACoC,eAAA;IACA,aAAA;EAkXtC;EA/WE;IACsC,gBAAA;EAiXxC;EA7W0C;IACE,eAAA;IACA,YAAA;EA+W5C;AACF;AAzWA;EACE;IACoC,aAAA;EA2WpC;EA1WE;IAAqC,kBAAA;EA6WvC;EA5WE;IAAqC,aAAA;EA+WvC;EA9WE;IACoC,YAAA;IACA,UAAA;IACA,mBAAA;IACA,mBAAA;IACA,eAAA;EAgXtC;EA/WsC;IAAO,iBAAA;EAkX7C;EAhXE;IACoC,UAAA;EAkXtC;EAhXsC;IACE,eAAA;EAkXxC;EAhXsC;IACE,eAAA;EAkXxC;EA9WE;IAEoC,WAAA;IACA,kBAAA;IACA,gBAAA;EA+WtC;EA7WE;IACoC,eAAA;EA+WtC;EA5WE;IACoC,gBAAA;EA8WtC;EA5WwC;IACE,eAAA;EA8W1C;AACF;AAxWA;EACE;IACE,sBAAA;EA0WF;EAvWA;IACE,YAAA;EAyWF;AACF","sourcesContent":["\n%flex-column            {\n                          display: flex;\n                          flex-direction: column;\n                        }\n\n%flex-row               {\n                          display: flex;\n                          flex-direction: row;\n                        }\n\n%flex-jCenter-aCenter   {\n                          justify-content: center;\n                          align-items: center;\n                        }\n\n%flex-jCenter-aStart    {\n                          justify-content: center;\n                          align-items: flex-start;\n                        }\n\n%flex-jCenter-aEnd      {\n                          justify-content: center;\n                          align-items: flex-end;\n                        }\n\n%flex-jStart-aCenter    {\n                          justify-content: flex-start;\n                          align-items: center;\n                        }\n\n%flex-jStart-aStart     {\n                          justify-content: flex-start;\n                          align-items: flex-start;\n                        }\n\n%flex-jStart-aEnd       {\n                          justify-content: flex-start;\n                          align-items: flex-end;\n                        }\n\n%flex-jEnd-aCenter      {\n                          justify-content: flex-end;\n                          align-items: center;\n                        }\n\n%flex-jEnd-aStart       {\n                          justify-content: flex-end;\n                          align-items: flex-start;\n                        }\n\n%flex-jEnd-aEnd         {\n                          justify-content: flex-end;\n                          align-items: flex-end;\n                        }\n\n","@import \"placeholders/flexboxes\";\n@import \"placeholders/fonts\";\n@import \"placeholders/quickStyles\";\n@import \"variables/breakpoints\";\n@import \"variables\";\n@import \"./../../../styles.scss\";\n\n.rDNA-dashboardContainer          {\n                                      height: 100%;\n                                      max-width:90vw;\n  .export-btn                       { border: 1px solid $dark-text; }\n  .rDNA-buttonBar                   { width: 100%; }\n  .rDNA-generalInfo                 { @extend %max-HW-100 }\n  .rDNA-metricsSection              { @extend %max-HW-100; }\n  .rDNA-rankings                    { @extend %max-HW-100;}\n  .rDNA-retailerSection             { @extend %max-HW-100; }\n  .rDNA-smBtnStack                  {\n                                      @extend %flex-column;\n                                      width:100%;\n   }\n\n  .rDNA-button                      {\n                                      border-radius: 15px;\n                                      @extend %font-20px-medium;\n                                      @extend %flex-column;\n                                      @extend %flex-jCenter-aCenter;\n                                      //min-width:100px;\n                                      &:last-of-type { margin-bottom: 0; }\n                                    }\n  .rDNA-prev-next-container         {\n\n                                      @extend %flex-column;\n                                      @extend %flex-jCenter-aCenter;\n\n\n                                      justify-content:space-around;\n                                      align-items: center;\n                                      background-color: $theme-lightgray;\n                                      border-radius:100px;\n\n                                      height:100px;\n                                      width:80%;\n                                      margin: 0;\n                                      padding:5% 10px;\n\n                                      .sub-container {\n                                        display:flex;\n                                        flex-direction:row;\n                                        height:50%;\n                                        align-items:center;\n                                      }\n\n                                      div {\n                                        width: 100%;\n                                        margin:0;\n                                        padding:0;\n                                        display:flex;\n                                        justify-content: space-around;\n\n\n                                      }\n\n                                      p {\n                                        @extend %font-20px-medium;\n                                        color:$theme-back;\n                                        margin:15px;\n\n                                      }\n\n                                      span {\n\n                                        color: $theme-lightgray;\n                                        font-weight: bold;\n                                        background-color: white;\n                                        border-radius: 100%;\n                                        border:none;\n                                        width:fit-content;\n                                        height:fit-content;\n                                        &:last-of-type{margin-left:5px}\n\n                                      }\n\n                                      span:hover {\n                                        color:$theme-main;\n\n                                      }\n  }\n  .rDNA-echelonContainer            {\n                                      display:flex;\n                                      flex-wrap: wrap;\n                                      justify-content: space-around;\n                                      //max-width: 80vw;\n                                    }\n  .rDNA-echelon                     {\n                                      //@extend %flex-row;\n                                      max-width: 100% !important;\n                                      ::ng-deep .echelon-header {\n                                        background: $dark-text;\n                                        border-radius: 10px;\n                                        > p {\n                                          @extend %font-24px-semi;\n                                          color: $light-text;\n                                        }\n                                      }\n                                      //::ng-deep .echelon { width: 100% !important;}\n                                      //.echelon-content-container { width: 100%; }\n                                    }\n  .rDNA-companyTitle                {\n                                      width: 100%;\n                                      @extend %flex-row;\n                                      @extend %flex-jStart-aCenter;\n                                      @extend %font-34px-bold;\n\n                                      div {\n                                        display:flex;\n                                        flex-wrap:wrap;\n                                      }\n                                      p {\n                                        margin:0\n                                      }\n\n                                      .clickable {\n                                        text-decoration: underline;\n                                        color:$dark-text\n\n                                      }\n\n                                      .clickable:hover{\n                                        cursor:pointer;\n                                        color:$accent-btn\n                                      }\n                                    }\n  .rDNA-companyTitleInList          {\n                                      width: 100%;\n                                      @extend %flex-row;\n                                      @extend %flex-jStart-aCenter;\n                                      @extend %font-20px-bold;\n\n                                      div {\n                                        display:flex;\n                                        flex-wrap:wrap;\n                                        p {\n                                          margin:0\n                                        }\n                                      }\n\n                                      .clickable {\n                                        text-decoration: underline;\n                                        color:$dark-text\n\n                                      }\n\n                                      .clickable:hover{\n                                        cursor:pointer;\n                                        color:$accent-btn\n                                      }\n                                    }\n  .rDNA-loader                      {\n                                      @extend %flex-column;\n                                      @extend %flex-jCenter-aCenter;\n                                      @extend %max-HW-100;\n                                    }\n  .share-btn                        {\n                                      color: $light-text;\n                                      background: $dark-text;\n                                    }\n  .compare-btn                      { // note: if you place this above the rDNA-button class, it will get overwritten due to hierarchical order\n                                      color: $light-text;\n                                      background: $accent-btn;\n\n                                      width: 100%;\n                                      //height:100%;\n                                      margin-right: 20px;\n                                      margin-bottom:10px;\n\n                                    }\n}\n@media screen and (max-width: $breakpoint-sm-max ) {\n  .rDNA-dashboardMobile {\n                                      background: $app-background;\n                                      padding: 0 25px 0 10px;\n    .rDNA-mobileWebDomain             {\n                                        display: flex;\n                                        margin-bottom: 10px;\n                                      }\n    .rDNA-companyName                 {\n                                        color: #282B59;\n                                        font-size: 30px;\n                                        font-family: \"DM Sans\", sans-serif;\n                                        font-weight: 700;\n                                        margin: 0 0 20px 10px;\n                                        padding-top: 15px;\n                                      }\n    .rDNA-companyNameInList                 {\n                                        color: #282B59;\n                                        font-size: 30px;\n                                        font-family: \"DM Sans\", sans-serif;\n                                        font-weight: 700;\n                                        margin: 0 0 20px 10px;\n                                        padding-top: 15px;\n                                      }\n    .rDNA-prev-next-container         {\n                                        display:flex;\n                                        flex-direction: row;\n                                        align-self:center;\n                                        justify-content:space-between;\n                                        align-items: center;\n                                        background-color: $theme-lightgray;\n                                        border-radius:40px;\n\n                                        margin: 5px 0px;\n                                        padding:0px 10px;\n\n                                        .ret-container {\n                                          display:flex;\n                                          flex-direction:row;\n                                          width:fit-content;\n                                          max-width:50%;\n                                          height:100%;\n                                          align-items: center;\n\n                                        }\n                                        div {\n                                          width: 50%;\n                                          display:flex;\n                                          justify-content: space-evenly;\n\n\n                                        }\n\n                                        p {\n                                          font-size:12px;\n                                          color:$theme-back;\n                                          margin:0 15px;\n\n                                        }\n\n                                        span {\n\n                                          color: $theme-lightgray;\n                                          font-weight: bold;\n                                          font-size: 30px;\n                                          background-color: white;\n                                          border-radius: 100%;\n                                          border:none;\n                                          width:fit-content;\n                                          height:fit-content;\n\n\n                                        }\n\n                                        span:hover {\n                                          color:$theme-main;\n\n                                        }\n    }\n    .rDNA-echelonContainer            {\n                                        max-width: 70vw;\n                                        justify-content: space-around;\n                                      }\n    .rDNA-echelon                     {\n                                        ::ng-deep .echelon {width: 100% !important; }\n                                        ::ng-deep .echelon-header {\n                                          background: $dark-text;\n                                          //padding-left: 10px;\n                                          > p {\n                                            color: $light-text !important;\n                                            font-size: 16px;\n                                            margin: 10px;\n                                          }\n                                        }\n                                      }\n    }\n}\n\n@media screen and ( max-width: $breakpoint-md-max) and (min-width: $breakpoint-md-min) {\n  .rDNA-dashboardContainer        {\n                                      padding: 5px;\n    .rDNA-companyTitle                {\n                                        font-size: 30px;\n                                        padding-left: 5px;\n                                      }\n    .rDNA-companyTitleInList                {\n                                        font-size: 20px;\n                                        padding-left: 5px;\n                                      }\n    .rDNA-button                      {\n                                        height: 25px;\n\n                                        margin-bottom: 5px;\n                                        font-size: 9px;\n                                        span { margin-left: 5px; }\n                                      }\n    .rDNA-prev-next-container         {\n                                        width:80%;\n                                        height:60px;\n\n\n                                        p {\n                                          font-size:12px;\n                                        }\n                                        span {\n                                          font-size:15px;\n                                        }\n    }\n    .compare-btn                      {\n                                        //height: 35px;\n                                        width: 100%;\n                                        margin-right: 10px;\n                                        margin-bottom: 0;\n                                      }\n    .rDNA-smBtnStack                  {\n                                        width:100%;\n\n                                      }\n\n    .rDNA-echelonContainer {justify-content: space-around;}\n    .rDNA-echelon                     {\n                                          margin-top: 10px;\n                                          //padding-left: 5px;\n                                          ::ng-deep .echelon-header {\n                                            //padding-left: 10px;\n                                            > p {\n                                              font-size: 16px;\n                                              margin: 10px;\n                                            }\n                                          }\n                                        }\n  }\n  .padlock-container{\n    position:relative\n  }\n  \n  \n  .padlock{\n    display:none\n  }\n  \n  .padlock.disabled{\n    display:block\n  }\n}\n\n@media screen and ( max-width: $breakpoint-lg-max) and (min-width: $breakpoint-lg-min) {\n  .rDNA-dashboardContainer        {\n                                      padding: 10px;\n    .rDNA-companyTitle                {  padding-left: 20px; }\n    .rDNA-companyTitleInList          {\n                                        font-size: 24px;\n                                        padding-left: 5px;\n                                      }\n\n    .rDNA-button                      {\n                                        height: 35px;\n                                        width: 45%;\n                                        margin-bottom: 5px;\n                                        font-size: 9px;\n                                        span { margin-left: 5px; }\n                                      }\n    .rDNA-prev-next-container         {\n                                        width:80%;\n\n                                        p {\n                                          font-size:16px;\n                                        }\n                                        span {\n                                          font-size: 25px;\n                                        }\n\n                                      }\n      .rDNA-smBtnStack {\n                                        width:50%;\n                                      }\n    .compare-btn                      {\n                                        //height: 35px;\n                                        width: 100%;\n                                        margin-right: 0px;\n                                        margin-bottom: 0;\n                                      }\n    .rDNA-echelonContainer {justify-content: space-around;}\n    .rDNA-echelon                     {\n                                          margin-top: 15px;\n                                          //padding-left: 5px;\n                                          ::ng-deep .echelon-header {\n                                            //padding-left: 10px;\n                                            > p {\n                                              font-size: 20px;\n                                              margin: 10px;\n                                            }\n                                          }\n                                        }\n  }\n}\n\n@media screen and (min-width:$breakpoint-2-charts) {\n  .rDNA-echelonContainer{justify-content: space-between !important;}\n}\n\n@media screen and ( max-width: $breakpoint-xxl-max) and (min-width: $breakpoint-lg-max) {\n  .rDNA-dashboardContainer        {\n                                         padding: 15px;\n    .rDNA-companyTitle                {  padding-left: 25px; }\n    .rDNA-companyTitleInList          {\n                                        font-size: 25px;\n                                        padding-left: 5px;\n                                      }\n\n                                      .rDNA-smBtnStack {width:50%;}\n    .rDNA-button                      {\n                                        height: 35px;\n                                        width: 45%;\n                                        margin-bottom: 10px;\n                                        font-size: 14px;\n                                        span { margin-left: 10px; }\n                                      }\n    .rDNA-prev-next-container         {\n                                        width:80%;\n\n                                        p {\n                                          font-size:16px;\n                                        }\n                                        span {\n                                          font-size: 28px;\n                                        }\n\n                                      }\n    .compare-btn                      {\n                                        //height: 55px;\n                                        width: 100%;\n                                        margin-right: 20px;\n                                        margin-bottom: 0;\n                                      }\n    .rDNA-echelonContainer            {\n                                        max-width: 90vw;\n                                        display:flex;\n\n                                      }\n    .rDNA-echelon                     {\n                                          margin-top: 20px;\n                                          //padding-left: 10px;\n                                          ::ng-deep .echelon-header {\n                                            //padding-left: 15px;\n                                            > p {\n                                              font-size: 24px;\n                                              margin: 10px;\n                                            }\n                                          }\n                                        }\n  }\n}\n\n@media screen and (min-width: $breakpoint-xxxl-min) {\n  .rDNA-dashboardContainer        {\n                                      padding: 25px;\n    .rDNA-companyTitle                {  padding-left: 32px; }\n    .rDNA-companyTitleInList          {  font-size:42 }\n    .rDNA-button                      {\n                                        height: 45px;\n                                        width: 45%;\n                                        margin-bottom: 20px;\n                                        border-radius: 15px;\n                                        font-size: 20px;\n                                        span { margin-left: 20px; }\n                                      }\n    .rDNA-prev-next-container         {\n                                        width:80%;\n\n                                        p {\n                                          font-size:20px;\n                                        }\n                                        span {\n                                          font-size: 28px;\n                                        }\n\n                                      }\n    .compare-btn                      {\n                                        //height: 75%;\n                                        width: 100%;\n                                        margin-right: 20px;\n                                        margin-bottom: 0;\n                                      }\n    .rDNA-echelonContainer            {\n                                        max-width: 90vw;\n\n                                      }\n    .rDNA-echelon                     {\n                                        margin-top: 35px;\n                                        ::ng-deep .echelon-header {\n                                          > p {\n                                            font-size: 24px;\n                                          }\n                                          //padding-left: 20px;\n                                        }\n                                      }\n  }\n}\n@media (max-width: 767px) {\n  .app-lb-banner{\n    flex-direction:column\n  }\n\n  app-lb-full-width-dropdown {\n    margin: 30px;\n  }\n}\n","@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-Black.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-Bold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBold.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-Medium.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Regular.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-Light.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLight.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: normal;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-Thin.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 900;\n  src: url('../assets/DM_Sans/static/DMSans-BlackItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 800;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 700;\n  src: url('../assets/DM_Sans/static/DMSans-BoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 600;\n  src: url('../assets/DM_Sans/static/DMSans-SemiBoldItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 500;\n  src: url('../assets/DM_Sans/static/DMSans-MediumItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 400;\n  src: url('../assets/DM_Sans/static/DMSans-Italic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 300;\n  src: url('../assets/DM_Sans/static/DMSans-LightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 200;\n  src: url('../assets/DM_Sans/static/DMSans-ExtraLightItalic.ttf');\n}\n\n@font-face {\n  font-family: 'DM Sans';\n  font-style: italic;\n  font-weight: 100;\n  src: url('../assets/DM_Sans/static/DMSans-ThinItalic.ttf');\n}\n\n","@import \"fonts\";\n\n// this file is more for variables that cannot be used in the theme\n// many of these should be migrated after the material theme has been configured.\n\n$font-family: \"Dm Sans\", sans-serif;\n\n/* Old palette\n$accent-btn: #DD7EB0;\n$dark-text: #303f71;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #84D9FD;*/\n\n$accent-btn: #0CAD99;\n$dark-text: #1B3E78;\n$light-text: #fff;\n$inactive-text: #A3AED0;\n$accent-blue: #3792BF;\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$app-background: #F4F7FE;\n\n$rDNA-success: #00B300;\n$rDNA-alert: #FF0000;\n$rDNA-neutral: #FFBF00;\n","@import '../mixins';\n\n/////////////////////////////////////\n//   Extra Bold Font Placeholders  //\n/////////////////////////////////////\n\n%font-16px-extra-bold { @include format-font(16px, 'extra bold'); }\n\n/////////////////////////////////////\n//     Bold Font Placeholders     //\n/////////////////////////////////////\n\n%font-52px-bold       { @include format-font(52px, 'bold'); }\n%font-48px-bold       { @include format-font(48px, 'bold'); }\n%font-34px-bold       { @include format-font(34px, 'bold'); }\n%font-32px-bold       { @include format-font(32px, 'bold'); }\n%font-28px-bold       { @include format-font(28px, 'bold'); }\n%font-24px-bold       { @include format-font(24px, 'bold'); }\n%font-20px-bold       { @include format-font(20px, 'bold'); }\n%font-18px-bold       { @include format-font(18px, 'bold'); }\n%font-16px-bold       { @include format-font(16px, 'bold'); }\n%font-14px-bold       { @include format-font(14px, 'bold'); }\n%font-12px-bold       { @include format-font(12px, 'bold'); }\n\n\n/////////////////////////////////////\n//   Semi-Bold Font Placeholders   //\n/////////////////////////////////////\n\n%font-24px-semi       { @include format-font(24px, 'semi-bold'); }\n%font-20px-semi       { @include format-font(20px, 'semi-bold'); }\n\n\n/////////////////////////////////////\n//     Medium Font Placeholders    //\n/////////////////////////////////////\n\n%font-30px-medium     { @include format-font(30px, 'medium'); }\n%font-20px-medium     { @include format-font(20px, 'medium'); }\n%font-18px-medium     { @include format-font(18px, 'medium'); }\n%font-16px-medium     { @include format-font(16px, 'medium'); }\n%font-14px-medium     { @include format-font(14px, 'medium'); }\n%font-12px-medium     { @include format-font(12px, 'medium'); }\n%font-10px-medium     { @include format-font(10px, 'medium'); }\n\n/////////////////////////////////////\n//    Normal Font Placeholders     //\n/////////////////////////////////////\n\n%font-18px-normal     { @include format-font(18px); }\n%font-16px-normal     { @include format-font(16px); }\n%font-14px-normal     { @include format-font(14px); }\n%font-12px-normal     { @include format-font(12px); }\n","@import 'variables';\n\n@mixin format-font($size, $weight: 500, $style: 'normal' ) {\n  @if ( $weight == 'thin' or $weight == 'Thin' ) { $weight: 100; }\n  @else if ( $weight == 'extra light' or $weight == 'Extra light' or $weight == 'extra Light' or $weight == 'Extra Light' or  $weight == 'el') { $weight: 200; }\n  @else if ( $weight == 'light' or $weight == 'Light'  or $weight == 'l') { $weight: 300; }\n  @else if ( $weight == 'normal' or $weight == 'Normal'  or $weight == 'n') { $weight: 400; }\n  @else if ( $weight == 'medium' or $weight == 'Medium'  or $weight == 'm') { $weight: 500; }\n  @else if ( $weight == 'semi-bold' or $weight == 'Semi-bold' or $weight == 'semi-Bold' or $weight == 'Semi-Bold' or $weight == 'sb' ) { $weight: 600; }\n  @else if ( $weight == 'bold' or $weight == 'Bold' or $weight == 'b' ) { $weight: 700; }\n  @else if ( $weight == 'extra bold' or $weight == 'Extra bold' or $weight == 'extra Bold' or $weight == 'Extra Bold' or $weight == 'eb' ) { $weight: 800; }\n  @else if ( $weight == 'black' or $weight == 'Black' or $weight == 'blk') { $weight: 900; }\n\n  @if ( $style == 'Italic' or $style == 'i' ) { $style: italic; }\n  @else { $style: normal; }\n\n  font-family: $font-family;\n  font-size: $size;\n  font-weight: $weight;\n  font-style: $style;\n}\n","\n%max-HW-100 {\n  height: 100%;\n  width: 100%;\n}\n\n%full-screen-background-overlay {\n  display: flex;\n  flex-direction: column;\n  z-index: 98;\n  background-color: rgba(#e0e0e0, 0.5);\n  backdrop-filter: blur(4px);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100dvw;\n  height: 100dvh;\n  align-items: center;\n  justify-content: center;\n}\n\n%white-background-raised-container {\n  height: fit-content;\n  max-height: 80dvh;\n  width: 70dvw;\n  border-radius: 50px;\n  background: white;\n  box-shadow: 20px 20px 20px #d9d9d9,\n  -20px -20px 20px #e0e0e0;\n  z-index: 99;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n// Base x-button style\n%x-button {\n  cursor: pointer;\n  z-index: 9999;\n\n  &:hover {\n    color: #333;\n  }\n}\n\n// Modifier: small\n%x-button--small {\n  position: absolute;\n  font-size: 0.75rem;\n  top: 0.5rem;\n  left: 14rem;\n  background: none;\n  color: grey;\n  border: none;\n}\n\n// Modifier: large\n%x-button--large {\n  position: absolute;\n  font-size: 1.25rem;\n  top: 0.2rem;\n  left: 0.2rem;\n  background: none;\n  color: grey;\n  border: none;\n}\n\n\n","/** Colors variables */\r\n\r\n$sb-primary: #2E4057 !default;\r\n$sb-accent: #fff !default;\r\n$sb-facebook: #4267B2 !default;\r\n$sb-twitter: #00acee !default;\r\n$sb-google: #db4437 !default;\r\n$sb-mix: #ff8226 !default;\r\n$sb-linkedin: #006fa6 !default;\r\n$sb-pinterest: #bd081c !default;\r\n$sb-reddit: #ff4006 !default;\r\n$sb-tumblr: #36465d !default;\r\n$sb-whatsapp: #25d366 !default;\r\n$sb-messenger: #0080FF !default;\r\n$sb-telegram: #0088cc !default;\r\n$sb-xing: #006567 !default;\r\n$sb-email: #FF961C !default;\r\n$sb-viber: #665ca7 !default;\r\n$sb-vk: #4C75A3 !default;\r\n$sb-copy: #607D8B !default;\r\n$sb-print: #765AA2 !default;\r\n$sb-sms: #20c16c !default;\r\n$sb-gray: #a5a5a5 !default;\r\n$sb-expand: #FF6651 !default;\r\n$sb-line: #00b900 !default;\r\n\r\n$sb-buttons: (\r\n  facebook: $sb-facebook,\r\n  twitter: $sb-twitter,\r\n  google: $sb-google,\r\n  mix: $sb-mix,\r\n  line: $sb-line,\r\n  linkedin: $sb-linkedin,\r\n  pinterest: $sb-pinterest,\r\n  reddit: $sb-reddit,\r\n  tumblr: $sb-tumblr,\r\n  whatsapp: $sb-whatsapp,\r\n  messenger: $sb-messenger,\r\n  telegram: $sb-telegram,\r\n  xing: $sb-xing,\r\n  sms: $sb-sms,\r\n  email: $sb-email,\r\n  viber: $sb-viber,\r\n  vk: $sb-vk,\r\n  copy: $sb-copy,\r\n  print: $sb-print,\r\n  expand: $sb-expand\r\n) !default;\r\n","@import \"variables\";\r\n\r\n.sb-default .sb-wrapper {\r\n  --sb-color: #{$sb-accent};\r\n  --sb-background: var(--button-color);\r\n  --sb-border-radius: 4px;\r\n  --sb-overflow: hidden;\r\n\r\n  &.sb-show-icon.sb-show-text {\r\n    --sb-text-padding: 0 1em 0 0;\r\n\r\n    .sb-text {\r\n      filter: none;\r\n    }\r\n  }\r\n}\r\n","@import \"variables\";\r\n\r\n$sb-text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);\r\n$sb-text-size: 0.8em;\r\n\r\n.sb-circles-dark, .sb-circles-light {\r\n  .sb-wrapper {\r\n    --sb-color: #{$sb-accent};\r\n    --sb-background: transparent;\r\n    --sb-min-width: fit-content;\r\n    --sb-height: fit-content;\r\n    --sb-icon-size: 1.4em;\r\n\r\n    &:active {\r\n      .sb-icon {\r\n        box-shadow: 0 7px 8px -4px rgba(0, 0, 0, .2), 0 12px 17px 2px rgba(0, 0, 0, .14), 0 5px 22px 4px rgba(0, 0, 0, .12);\r\n      }\r\n    }\r\n\r\n    .sb-icon {\r\n      background-color: var(--button-color);\r\n      box-shadow: 0 3px 5px -1px rgba(0, 0, 0, .2), 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12);\r\n      width: 2.5em;\r\n      min-height: 2.5em;\r\n      border-radius: 50%;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-text {\r\n      color: var(--button-color);\r\n      font-size: $sb-text-size;\r\n      margin-top: 5px;\r\n      border-radius: 1em;\r\n      width: 100%;\r\n      height: 1.8em;\r\n      line-height: 1.8em;\r\n      padding: 0;\r\n      transition: background .4s cubic-bezier(.25, .8, .25, 1), box-shadow 280ms cubic-bezier(.4, 0, .2, 1);\r\n    }\r\n\r\n    .sb-content {\r\n      align-items: center;\r\n      flex-direction: column;\r\n    }\r\n  }\r\n}\r\n\r\n.sb-circles-dark .sb-wrapper {\r\n\r\n  .sb-icon {\r\n    background-color: var(--button-color);\r\n  }\r\n\r\n  .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n}\r\n\r\n.sb-circles-light .sb-wrapper {\r\n\r\n  .sb-icon, .sb-text {\r\n    color: var(--button-color);\r\n  }\r\n\r\n  .sb-icon {\r\n    background: radial-gradient(ellipse farthest-corner at center, white 30%, darken(white, 5%) 100%);\r\n  }\r\n}\r\n","\n@import \"../node_modules/ngx-sharebuttons/themes/default.scss\";\n@import \"../node_modules/ngx-sharebuttons/themes/circles.scss\";\n\n/* You can add global styles to this file, and also import other style files */\n\nbody, html {\nheight: 100vh;\n// width: 100vh;\nmargin: 0;\n}\n\nbody {\n    font-family: Arial, sans-serif;\n    height: 100vh;\n    background-color: #fff; /* Background color for the top half */\n    position: relative;\n    display: block;\n    justify-content: center;\n    align-items: center;\n    }\n\n\nbody::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 50%;\n    background: #fff;\n\n\n    z-index: -1; /* Ensure the gradient is behind other content */\n}\n\n\n$theme-back: #2D2D2A;\n/* Old palette\n$theme-main: #B05995;\n$theme-contrast: #3792BF;\n$theme-1: #282B59;\n$theme-2: #D683DD;\n$theme-3: #27567A;\n$theme-4: #44DDC4;\n$theme-5: #3336AE;\n$theme-6: #18C43D;\n*/\n\n$theme-main: #1B3E78;\n$theme-contrast: #0CAD99;\n$theme-1: #3792BF;\n$theme-2: #AACCFF;\n$theme-3: #BDBDBD;\n$theme-4: #7D7979;\n$theme-5: #787c95;\n\n$theme-primary: #3792BF;\n$theme-secondary: #1B3E78;\n$theme-color3: #AACCFF;\n$theme-color4: #BDBDBD;\n$theme-color5: #7D7979;\n$theme-accent: #0CAD99;\n$text-gray:#787c95;\n$theme-red:#d9534f;\n\n$theme-back-light: #4c4c47;\n$theme-lightgray: #e7e7e7;\n$theme-gray-text: #787476;\n\n$theme-table-header: #f6f6f6;\n$theme-table-body:#f8f8f8;\n$theme-source:#9E9E9E;\n\n\n$value-chain-1: #44DDC4;\n$value-chain-2: \"\";\n$value-chain-3: \"\";\n$value-chain-4: \"\";\n\n.material-symbols-outlined {\n\n    cursor: pointer;\n    font-variation-settings:\n        'FILL' 0,\n        'wght' 400,\n        'GRAD' 0,\n        'opsz' 48;\n}\n\np {\n    font-family:Arial, Helvetica, sans-serif;\n    text-align: justify;\n    color: $theme-back;\n}\n\n\n\nhtml, body { height: 100%; }\nbody { margin: 0; font-family: Roboto, \"Helvetica Neue\", sans-serif; }\n\n\n.generic-button, .generic-button-alt {\n  color: white;\n  border-radius: 5px;   /* Rounded corners */\n    padding: 10px 20px;    /* Padding for button size */\n    margin-right: 10px;\n\n    // font-size: 16px;       /* Font size */\n    cursor: pointer;       /* Pointer on hover */\n    transition: background-color 0.3s; /* Smooth transition on hover */\n\n    p {\n        color:white;\n        margin:0;\n    }\n}\n.generic-button {\n  background-color: $theme-main; /* Button background color */\n  border: 2px solid $theme-main;      /* No border */\n}\n\n.generic-button-alt {\n  background-color: $theme-accent; /* Button background color */\n  border: 2px solid $theme-accent;      /* No border */\n}\n\n.generic-button:hover {\n    background-color: #fff; /* Change color on hover */\n    color: $theme-main;\n\n    p {\n        color: $theme-main\n    }\n}\n\n.generic-button-alt:hover {\n  background-color: #fff; /* Change color on hover */\n  color: $theme-accent;\n\n  p {\n    color: $theme-accent\n  }\n}\n\n.generic-button:disabled, .generic-button-alt:disabled {\n    background-color: $theme-lightgray;\n    border-color: $theme-lightgray;\n    cursor:not-allowed;\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
